// Récapitulatif de règlement inséré dans le texte pré-rempli des emails de facture.
// Trois cas : (a) ni avoir imputé ni règlement -> rien, le texte reste inchangé ;
// (b) reste dû -> détail puis « Reste à payer » en dernier ; (c) soldée -> aucun règlement attendu.
// Le placeholder {total_ttc} n'est JAMAIS détourné : {reste_a_payer} existe pour cela.

import { billedTtc } from "./documentAmounts";

export const formatEur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export function invoiceSituation(doc) {
  if (!doc) return null;
  if (doc.type && doc.type !== "facture") return null;
  const imputed = Number(doc.avoir_imputed_ttc || 0);
  const paid = Number(doc.total_paid || 0);
  if (imputed <= 0.009 && paid <= 0.009) return null;
  // Base = montant réellement facturé (acomptes déjà émis déduits), comme le PDF.
  // Partir de total_ttc faisait annoncer au client « 12 000 − 3 000 = 1 000 » sur une
  // facture de solde : une soustraction fausse dans le corps du message.
  const totalTtc = billedTtc(doc);
  const reste = doc.remaining != null ? Number(doc.remaining) : totalTtc - imputed - paid;
  return {
    totalTtc,
    imputed,
    paid,
    reste,
    numbers: doc.avoir_imputed_numbers || [],
    date: new Date().toLocaleDateString("fr-FR"),
  };
}

export function invoiceRecapText(doc) {
  const s = invoiceSituation(doc);
  if (!s) return "";
  if (s.reste <= 0.009) return "Facture soldée — aucun règlement attendu.";
  const lines = [`Montant TTC : ${formatEur(s.totalTtc)}`];
  if (s.imputed > 0.009) {
    const plural = s.numbers.length > 1 ? "s" : "";
    const refs = s.numbers.length ? ` ${s.numbers.join(", ")}` : "";
    lines.push(`Avoir${plural}${refs} imputé${plural} : \u2212\u00a0${formatEur(s.imputed)}`);
  }
  if (s.paid > 0.009) lines.push(`Règlements reçus : \u2212\u00a0${formatEur(s.paid)}`);
  lines.push(`Reste à payer au ${s.date} : ${formatEur(s.reste)}`);
  return lines.join("\n");
}

export function invoiceRestePayer(doc) {
  const s = invoiceSituation(doc);
  return formatEur(s ? s.reste : billedTtc(doc));
}

// Règle anti-doublon : si le modèle contient déjà {reste_a_payer}, on n'ajoute rien.
export function appendRecapToTemplate(template, rendered, doc) {
  const recap = invoiceRecapText(doc);
  if (!recap || (template || "").includes("{reste_a_payer}")) return rendered;
  return `${rendered}\n\n${recap}`;
}
